import { getLocalStorageItem, setLocalStorageItem } from '../localStorageUtils';
const RECOMMENDATIONS_BASE_STORAGE_KEY = 'reporting-recommendations';
const DEMOGRAPHICS_KEY = `demographics`;
const getStoredRecommendationData = () => {
  const fromStorage = getLocalStorageItem(RECOMMENDATIONS_BASE_STORAGE_KEY);
  if (fromStorage) {
    return JSON.parse(fromStorage);
  }
  return null;
};
export const getDemographicsDataForUser = userId => {
  var _fromStorage$DEMOGRAP;
  const fromStorage = getStoredRecommendationData();
  return fromStorage === null || fromStorage === void 0 || (_fromStorage$DEMOGRAP = fromStorage[DEMOGRAPHICS_KEY]) === null || _fromStorage$DEMOGRAP === void 0 ? void 0 : _fromStorage$DEMOGRAP[userId];
};
const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;
export const setDemographicsDataForUser = (userId, data) => {
  const expireDate = new Date(Date.now() + THIRTY_DAYS_IN_MS);
  const oldStorage = getStoredRecommendationData() || {
    [DEMOGRAPHICS_KEY]: {}
  };
  oldStorage[DEMOGRAPHICS_KEY][userId] = Object.assign({}, data, {
    expireDate
  });
  setLocalStorageItem(RECOMMENDATIONS_BASE_STORAGE_KEY, JSON.stringify(oldStorage));
};